export default __webpack_public_path__ + "static/media/portfolioMasters.4771fba0.png";